import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createContext, __DEV__ } from "@chakra-ui/utils";
import * as React from "react";

var _createContext = createContext({
  strict: false,
  name: "PortalManagerContext"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    PortalManagerContextProvider = _createContext2[0],
    usePortalManager = _createContext2[1];

export { usePortalManager };
export function PortalManager(props) {
  var children = props.children,
      zIndex = props.zIndex;
  return /*#__PURE__*/React.createElement(PortalManagerContextProvider, {
    value: {
      zIndex: zIndex
    }
  }, children);
}

if (__DEV__) {
  PortalManager.displayName = "PortalManager";
}